import{AnimationFrameAction as r}from"./AnimationFrameAction.js";import{AnimationFrameScheduler as m}from"./AnimationFrameScheduler.js";var o=new m(r),i=o;export{i as animationFrame,o as animationFrameScheduler};
